import {
  LOADING_CR_TOGGLE,
  CR_TOGGLE_SUCCESS,
  CR_TOGGLE_ERROR,
  LOADING_BULK_APPROVE_PREVIEW,
  GET_BULK_APPROVE_PREVIEW,
  GET_BULK_APPROVE_PREVIEW_ERROR,
  LOADING_BULK_APPROVE_EXECUTE,
  BULK_APPROVE_EXECUTE_SUCCESS,
  BULK_APPROVE_EXECUTE_ERROR,
  LOADING_REVENUE_RESET_PREVIEW,
  GET_REVENUE_RESET_PREVIEW,
  GET_REVENUE_RESET_PREVIEW_ERROR,
  LOADING_REVENUE_RESET_EXECUTE,
  REVENUE_RESET_EXECUTE_SUCCESS,
  REVENUE_RESET_EXECUTE_ERROR,
  LOADING_OPEN_CRS,
  GET_OPEN_CRS,
  GET_OPEN_CRS_ERROR,
  LOADING_CR_CLEAN,
  CR_CLEAN_SUCCESS,
  CR_CLEAN_ERROR,
  LOADING_SET_SUPERCUTOFF,
  SET_SUPERCUTOFF_SUCCESS,
  SET_SUPERCUTOFF_ERROR,
  LOADING_PROGRESS,
  GET_PROGRESS,
  GET_PROGRESS_ERROR,
  LOADING_ERRORS,
  GET_ERRORS,
  GET_ERRORS_ERROR,
  LOADING_RETRY_ERRORS,
  RETRY_ERRORS_SUCCESS,
  RETRY_ERRORS_ERROR,
  LOADING_CR_STATUS,
  GET_CR_STATUS,
  GET_CR_STATUS_ERROR,
  LOADING_STATE,
  GET_STATE,
  GET_STATE_ERROR,
  LOADING_COMPLETE_ERRORS,
  COMPLETE_ERRORS_SUCCESS,
  COMPLETE_ERRORS_ERROR,
} from '../../../actions/core/supercutoff/supercutoff'

const initialState = {
  // Loading per ogni operazione
  loadingCrToggle: false,
  loadingBulkApprovePreview: false,
  loadingBulkApproveExecute: false,
  loadingRevenueResetPreview: false,
  loadingRevenueResetExecute: false,
  loadingOpenCrs: false,
  loadingCrClean: false,
  loadingSetSupercutoff: false,
  loadingProgress: false,
  loadingErrors: false,
  loadingRetryErrors: false,
  loadingCrStatus: false,

  // Loading dedicati alla persistenza dello stato wizard (BE source of truth)
  loadingWizardState: false,
  loadingCompleteErrors: false,

  // Dati per ogni step
  crToggleResult: null,          // { status, crAvailable, updatedAt }
  bulkApprovePreview: null,      // { hours_to_approve, expenses_to_approve }
  bulkApproveResult: null,       // { hours_approved, expenses_approved }
  revenueResetPreview: null,     // { budgets_to_reset, budget_details[] }
  revenueResetResult: null,      // { budgets_reset }
  openCrs: null,                 // [{ pfe_id, project_code, pm_name, pm_email, status }]
  crCleanResult: null,           // { processed, results[] }
  supercutoffResult: null,       // { status, cutoff_date, total_budgets_to_process, execution_id }
  progress: null,                // { execution_id, total, processed, remaining, errors, progress_percentage, status }
  errors: null,                  // [{ id, budget_id, project_code, error_message, error_type, retry_count, status, created_at }]
  retryResult: null,             // { retried, results[] }
  crStatus: null,                // { crAvailable: boolean } — null finché non caricato

  // Snapshot del wizard restituito da GET /supercutoff/state. Null finché non caricato
  // o quando non esiste una run attiva (idratazione fallback su buildInitialState).
  // Shape:
  //   {
  //     execution_id, cutoff_month, cutoff_year, active_step_id,
  //     cr_available, triggered_by, status,
  //     steps: [{ step_id, status, result_json, completed_at }]
  //   }
  wizardState: null,
  wizardStateError: false,       // pilotato da Task 3.7: mostra Message + retry inline
  completeErrorsResult: null,    // { status, current_step }
}

export default (state = initialState, action) => {
  switch (action.type) {

    // ── CR Toggle ──────────────────────────────────────────
    case LOADING_CR_TOGGLE:
      return { ...state, loadingCrToggle: true }
    case CR_TOGGLE_SUCCESS:
      return { ...state, loadingCrToggle: false, crToggleResult: action.data }
    case CR_TOGGLE_ERROR:
      return { ...state, loadingCrToggle: false }

    // ── Bulk Approve Preview ───────────────────────────────
    case LOADING_BULK_APPROVE_PREVIEW:
      return { ...state, loadingBulkApprovePreview: true }
    case GET_BULK_APPROVE_PREVIEW:
      return { ...state, loadingBulkApprovePreview: false, bulkApprovePreview: action.data }
    case GET_BULK_APPROVE_PREVIEW_ERROR:
      return { ...state, loadingBulkApprovePreview: false }

    // ── Bulk Approve Execute ───────────────────────────────
    case LOADING_BULK_APPROVE_EXECUTE:
      return { ...state, loadingBulkApproveExecute: true }
    case BULK_APPROVE_EXECUTE_SUCCESS:
      return { ...state, loadingBulkApproveExecute: false, bulkApproveResult: action.data }
    case BULK_APPROVE_EXECUTE_ERROR:
      return { ...state, loadingBulkApproveExecute: false }

    // ── Revenue Reset Preview ──────────────────────────────
    case LOADING_REVENUE_RESET_PREVIEW:
      return { ...state, loadingRevenueResetPreview: true }
    case GET_REVENUE_RESET_PREVIEW:
      return { ...state, loadingRevenueResetPreview: false, revenueResetPreview: action.data }
    case GET_REVENUE_RESET_PREVIEW_ERROR:
      return { ...state, loadingRevenueResetPreview: false }

    // ── Revenue Reset Execute ──────────────────────────────
    case LOADING_REVENUE_RESET_EXECUTE:
      return { ...state, loadingRevenueResetExecute: true }
    case REVENUE_RESET_EXECUTE_SUCCESS:
      return { ...state, loadingRevenueResetExecute: false, revenueResetResult: action.data }
    case REVENUE_RESET_EXECUTE_ERROR:
      return { ...state, loadingRevenueResetExecute: false }

    // ── Open CRs ──────────────────────────────────────────
    case LOADING_OPEN_CRS:
      return { ...state, loadingOpenCrs: true }
    case GET_OPEN_CRS:
      return { ...state, loadingOpenCrs: false, openCrs: action.data }
    case GET_OPEN_CRS_ERROR:
      return { ...state, loadingOpenCrs: false }

    // ── CR Clean ──────────────────────────────────────────
    case LOADING_CR_CLEAN:
      return { ...state, loadingCrClean: true }
    case CR_CLEAN_SUCCESS:
      return { ...state, loadingCrClean: false, crCleanResult: action.data }
    case CR_CLEAN_ERROR:
      return { ...state, loadingCrClean: false }

    // ── Set SuperCutoff ────────────────────────────────────
    case LOADING_SET_SUPERCUTOFF:
      return { ...state, loadingSetSupercutoff: true }
    case SET_SUPERCUTOFF_SUCCESS:
      return { ...state, loadingSetSupercutoff: false, supercutoffResult: action.data }
    case SET_SUPERCUTOFF_ERROR:
      return { ...state, loadingSetSupercutoff: false }

    // ── Progress ───────────────────────────────────────────
    case LOADING_PROGRESS:
      return { ...state, loadingProgress: true }
    case GET_PROGRESS:
      return { ...state, loadingProgress: false, progress: action.data }
    case GET_PROGRESS_ERROR:
      return { ...state, loadingProgress: false }

    // ── Errors ─────────────────────────────────────────────
    case LOADING_ERRORS:
      return { ...state, loadingErrors: true }
    case GET_ERRORS:
      return { ...state, loadingErrors: false, errors: action.data.errors }
    case GET_ERRORS_ERROR:
      return { ...state, loadingErrors: false }

    // ── Retry Errors ───────────────────────────────────────
    case LOADING_RETRY_ERRORS:
      return { ...state, loadingRetryErrors: true }
    case RETRY_ERRORS_SUCCESS:
      return {
        ...state,
        loadingRetryErrors: false,
        retryResult: action.data,
        // Aggiorna lo stato degli errori ritentati nella lista locale
        errors: state.errors
          ? state.errors.map(e =>
              action.data.results.some(r => r.error_id === e.id)
                ? { ...e, status: 'retried', retry_count: e.retry_count + 1 }
                : e
            )
          : null,
      }
    case RETRY_ERRORS_ERROR:
      return { ...state, loadingRetryErrors: false }

    // ── CR Status ──────────────────────────────────────────
    case LOADING_CR_STATUS:
      return { ...state, loadingCrStatus: true }
    case GET_CR_STATUS:
      // Normalizza a booleano stretto: protegge da valori non-bool nella response
      return {
        ...state,
        loadingCrStatus: false,
        crStatus: { crAvailable: action.data.crAvailable === true },
      }
    case GET_CR_STATUS_ERROR:
      return { ...state, loadingCrStatus: false }

    // ── Wizard State (BE source of truth) ──────────────────
    case LOADING_STATE:
      // Reset dell'errore al nuovo tentativo, così la UI di Task 3.7
      // smette di mostrare il fallback durante il retry.
      return { ...state, loadingWizardState: true, wizardStateError: false }
    case GET_STATE:
      return {
        ...state,
        loadingWizardState: false,
        wizardStateError: false,
        wizardState: action.data,
      }
    case GET_STATE_ERROR:
      return { ...state, loadingWizardState: false, wizardStateError: true }

    // ── Errors Complete (transizione step 'errors' → 'cr_unblock') ──
    case LOADING_COMPLETE_ERRORS:
      return { ...state, loadingCompleteErrors: true }
    case COMPLETE_ERRORS_SUCCESS:
      return { ...state, loadingCompleteErrors: false, completeErrorsResult: action.data }
    case COMPLETE_ERRORS_ERROR:
      return { ...state, loadingCompleteErrors: false }

    default:
      return state
  }
}
